export default __webpack_public_path__ + "static/media/piedestal.b56f23f5.png";